import * as React from "react";
import Container from "./styled";
import { BsCheckLg } from "react-icons/bs";
import { Link } from "react-scroll";

export default function Cubrimos() {
  return (
    <Container>
      {/* Logos Container */}
      <div className="logosContainer">
        {/* Logo */}
        <img
          alt="Prudencia Seguros Logo"
          src="images/logos/prudenciaseguros.png"
          id="prudenciaLogo"
          className="topInOpacity8"
        ></img>
        {/* Logo */}
        <img
          alt="Federación Patronal Seguros S.A. Logo"
          src="images/logos/federacionpatronalseguros.png"
          id="patronalLogo"
          className="topInOpacity8"
        ></img>
        {/* Logo */}
        <img
          alt="Grupo Asegurador La Segunda Logo"
          src="images/logos/lasegunda.png"
          id="segundaLogo"
          className="topInOpacity8"
        ></img>
      </div>
      {/* Mucho para Vos Container */}
      <div className="muchoParaVosContainer opacidad08">
        {/* Title */}
        <h2>¡Hay mucho para vos y tu bici!</h2>
        {/* Cubrimos Container */}
        <div className="cubrimosContainer">
          {/* Columna 1 */}
          <div className="cubrimosColumn">
            {/* Cubre */}
            <div className="cubre">
              <p>
                <span>
                  <BsCheckLg />
                </span>
                Robo
              </p>
            </div>
            <div className="line-break"></div>
            {/* Cubre */}
            <div className="cubre">
              <p>
                <span>
                  <BsCheckLg />
                </span>
                Daños totales
              </p>
            </div>
          </div>
          {/* Columna 2 */}
          <div className="cubrimosColumn">
            {/* Cubre */}
            <div className="cubre">
              <p>
                <span>
                  <BsCheckLg />
                </span>
                Daños a terceros
              </p>
            </div>
            {/* Cubre */}
            <div className="cubre">
              <p>
                <span>
                  <BsCheckLg />
                </span>
                Accidentes personales
              </p>
            </div>
          </div>
          {/* Columna 3 */}
          <div className="cubrimosColumn">
            {/* Cubre */}
            <div className="cubre">
              <p>
                <span>
                  <BsCheckLg />
                </span>
                Auxilio y remolque
              </p>
            </div>
            {/* Cubre */}
            <div className="cubre">
              <p>
                <span>
                  <BsCheckLg />
                </span>
                Descuentos en service
              </p>
            </div>
          </div>
        </div>
        {/* Cotizar Button */}
        <Link to="header" smooth={true} spy={true} duration={300}>
          ¡Cotizá tu bici!
        </Link>
      </div>
    </Container>
  );
}
